import { render } from "./FeatureSection.vue?vue&type=template&id=5616a832"
import script from "./FeatureSection.vue?vue&type=script&lang=js"
export * from "./FeatureSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__